import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureSection from './components/FeatureSection';
import BidManagement from './components/BidManagement';
import JobFinder from './components/JobFinder';
import WinMoreBids from './components/WinMoreBids';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Demo from './pages/Demo';
import Platform from './pages/Platform';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import Pricing from './pages/Pricing';
const Home = () => {
  return <>
      <main className="flex-grow" data-id="element-0">
        <Hero data-id="element-1" />
        <FeatureSection data-id="element-2" />
        <JobFinder data-id="element-3" />
        <BidManagement data-id="element-4" />
        <WinMoreBids data-id="element-5" />
        <CTASection data-id="element-6" />
      </main>
    </>;
};
export function App() {
  return <Router data-id="element-7">
      <div className="flex flex-col min-h-screen w-full" data-id="element-8">
        <Navbar data-id="element-9" />
        <Routes data-id="element-10">
          <Route path="/" element={<Home data-id="element-12" />} data-id="element-11" />
          <Route path="/demo" element={<Demo data-id="element-14" />} data-id="element-13" />
          <Route path="/platform" element={<Platform data-id="element-16" />} data-id="element-15" />
          <Route path="/solutions" element={<Solutions data-id="element-18" />} data-id="element-17" />
          <Route path="/resources" element={<Resources data-id="element-20" />} data-id="element-19" />
          <Route path="/pricing" element={<Pricing data-id="element-22" />} data-id="element-21" />
        </Routes>
        <Footer data-id="element-23" />
      </div>
    </Router>;
}